var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { createDispatchHook, createSelectorHook, createStoreHook, Provider, } from 'react-redux';
import { allInitialState } from '../slice/__all__';
import { buildSaucerStore, defaultSaucerStore, } from '../store';
var SaucerContext = React.createContext({
    store: defaultSaucerStore,
    storeState: allInitialState,
});
SaucerContext.displayName = 'SaucerContext';
export var SaucerProvider = React.memo(function (props) {
    var store = useMemo(function () { return buildSaucerStore(__assign({}, props)); }, []);
    return (React.createElement(Provider, { store: store, context: SaucerContext }, props.children));
});
SaucerProvider.displayName = 'SaucerProvider';
export var useSaucerSelector = createSelectorHook(SaucerContext);
export var useSaucerDispatch = createDispatchHook(SaucerContext);
export var useSaucerStore = createStoreHook(SaucerContext);
